/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Paid_ColInputs */

const vi_order_paid_col = /** @type {(inputs: Order_Paid_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã trả`)
};

/**

* @param {Order_Paid_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_paid_col = /** @type {((inputs?: Order_Paid_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Paid_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_paid_col(inputs)
});